const PainelVal = (props) => {


    let { ling, specs, valid, onCritChange2, sh2, onSpecChange2, onSpecBlur2, cparte2 } = {...props};

    function validPainel (lim) {
        let x = valid (lim, specs.lims, specs.comp, specs.crit, specs.od, ling);
        let s = {...specs};
        s.lims[lim] = x;
        props.setSpecs(s);
    }

    function serv (specs, serv) {
        specs.res = null;
        if (specs.crit !== "Ranking") {
            specs.crit = "Intervalo";
            if (serv === 'pomp') {
                specs.lims = props.varGlob.refLim['pomp'][0];
                specs.crit = "Intervalo T";
            } else {
                specs.lims = props.varGlob.refLim[serv];
            }
        }
        props.setSpecs(specs);
        props.setComp(serv);
    }
    
    let promptSem = "1 (Dom) a 7 (Sáb)   vazio: todos";
    if (ling === 'uk') promptSem = "1 (Sun) to 7 (Sat)   empty: all";
    let prompt = "Disponível Jan2019-Fev2021";
    if (ling === 'uk') prompt = "Jan2019-Feb2021 available";


    return ( 
        <div className="painelval">
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: 'top'}}>Usando como critério:  </td>
                        <td className="bgrd" style={{verticalAlign: 'top', paddingBottom: '10px'}}>
                            <input type="radio" id="rank" name="rankint" value="Ranking" 
                                onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'val'))} defaultChecked={props.specs.crit === 'Ranking'}></input>
                            <span style={{verticalAlign: 'top'}}>Ranking</span>
                            <input type="radio" id="interv" name="rankint" value="Intervalo"
                                onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'val'))} defaultChecked={props.specs.crit === 'Intervalo'}></input>
                            <span style={{verticalAlign: 'top'}}> Intervalo </span>
                        </td>
                    </tr>
                </tbody>
            </table> 
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{paddingBottom: '10px'}}> Limites: </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l1" value={props.specs.lims[0]} maxLength="6" size="3" onBlur={() => validPainel(0)} onChange={(e)=> props.setSpecs(sh2(0, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l2" value={props.specs.lims[1]} maxLength="6" size="2" onBlur={() => validPainel(1)} onChange={(e)=> props.setSpecs(sh2(1, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l3" value={props.specs.lims[2]} maxLength="6" size="2" onBlur={() => validPainel(2)} onChange={(e)=> props.setSpecs(sh2(2, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l4" value={props.specs.lims[3]} maxLength="6" size="2" onBlur={() => validPainel(3)} onChange={(e)=> props.setSpecs(sh2(3, e.target.value, {...props.specs}))}></input>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="serv">
                <tbody>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: 'top', textAlign: 'left'}}>DSem:  </td>
                        <td className="bgrd" style={{verticalAlign: 'top'}}>
                            <input type="text" id="Tipo" value={props.specs.tipo} placeholder={promptSem} onChange={(e) => props.setSpecs(onSpecChange2(e, 'tipo', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'tipo', {...props.specs}))}>
                            </input> </td>
                        <td className="bgrd"><button style={{fontWeight: 'normal', padding: '1px 12px', backgroundColor: props.specs.fer? "black" : "#F0F0F0", color: props.specs.fer? "white": "black"}} id="fer" onClick={() => props.setSpecs(cparte2('fer', {...props.specs})) }> Fer.</button></td>
                        <td className="bgrd"><button style={{fontWeight: 'normal',padding: '1px 8px', backgroundColor: props.specs.nfer? "black" : "#F0F0F0", color: props.specs.nfer? "white": "black"}} id="nfer" onClick={() => props.setSpecs(cparte2('nfer', {...props.specs})) }> Não</button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left'}}>Anos:  </td>
                        <td className="bgrd">
                            <input type="text" id="Anos" value={props.specs.anos} placeholder={prompt} onChange={(e) => props.setSpecs(onSpecChange2(e, 'anos', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'anos', {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{width: '75px'}}>
                            <button style={{padding: '1px 8px'}}
                            type="button" title={props.TitA1}
                            onClick={() => serv (specs, props.RefA1) }>
                            {props.BotA1} </button>
                        </td>
                        <td className="bgrd">
                            <button style={{padding: '1px 8px'}}
                            type="button" title="Colorir troços em função do número de cartões usados"
                            onClick={() => serv (specs, "cart") }>
                            Cart </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left'}}>Meses: </td>
                        <td className="bgrd">
                            <input type="text" id="Meses" value={props.specs.meses} onChange={(e) => props.setSpecs(onSpecChange2(e, 'meses', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'meses', {...props.specs}))}></input>
                        </td>
                        <td className="bgrd">
                            <button style={{padding: '1px 8px'}}
                            type="button" title="Colorir estações em função do número de viagens"
                            onClick={() => serv (specs, "odv") }>
                            OD Vi </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left', paddingBottom: '10px'}}>Horas:  </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="Horas" value={props.specs.horas} onChange={(e) => props.setSpecs(onSpecChange2(e, 'horas', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'horas', {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <button style={{padding: '1px 18px'}}
                            type="button" title="Colorir estações em função da procura e/ou oferta"
                            onClick={() => serv (specs, "pomp") }>
                            PO </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{paddingBottom: '7px'}}>DMês:  </td>
                        <td className="bgrd">
                            <input type="text" id="DMes" onChange={(e) => props.setSpecs(onSpecChange2(e, 'dmes', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'dmes', {...props.specs}))}></input></td>
                        <td className="bgrd">
                            <button type="button" style={{width: '60px', height: '21px', padding: '1px 3px'}} title="Colorir troços em função da oferta (DETALHES)"
                            onClick={() => serv (specs, "tms") }>
                            TMS </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default PainelVal;